module.exports = __webpack_public_path__ + "img/loading.c09b0aff.gif";